import React from 'react';
import * as PropTypes from "prop-types";
import '../../resources/css/application.css';

const CookieDialog = (props) => {

    const {open, onClose} = props;

    return (
      <div>
          <div className="modal">
              <div className="modal-dialog modal-md modal-dialog-centered">
                  <div className="modal-content">
                      <div className="modal-header justify-content-center mb-5">
                          <h3 className="headline-3 text-center">Obavijest o kolačićima</h3>
                      </div>
                      <div className="modal-body justify-content-center mb-5">
                          <p className="text-center">Ako nastavite s korištenjem ove stranice automatski će se prikupiti nužni kolačići u svrhu funkcioniranja stranice i dostave dokumentacije. Ovi kolačići ne pohranjuju nikakve informacije koje bi vas mogle identificirati</p>
                      </div>
                      <div className="modal-footer justify-content-center">
                          <button type="button" data-dismiss="modal" aria-label="Close"
                                  className="btn btn--primary btn--xs-full-width"
                                  onClick={() => onClose()}>Zatvori
                          </button>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    );
};

CookieDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
};

export default CookieDialog;